import { defineMessage, defineMessages } from 'react-intl'

export enum FIRST_TIME_MODAL_BUTTON_LABELS {
  GOT_IT = 'GOT_IT',
  BOOK_NOW = 'BOOK_NOW',
  CONTACT_TO_BOOK = 'CONTACT_TO_BOOK',
}

export const MODAL_CONFIRMATION_PRIMARY_BUTTON_TEXT = defineMessages({
  [FIRST_TIME_MODAL_BUTTON_LABELS.BOOK_NOW]: {
    defaultMessage: 'Book now',
    description: 'Button text. Clicking will acknowledge and close the modal',
  },
  [FIRST_TIME_MODAL_BUTTON_LABELS.CONTACT_TO_BOOK]: {
    defaultMessage: 'Contact to book',
    description: 'Button text. Clicking will acknowledge and close the modal',
  },
  [FIRST_TIME_MODAL_BUTTON_LABELS.GOT_IT]: {
    defaultMessage: 'Got it',
    description: 'Button text. Clicking will acknowledge and close the modal',
  },
})

export const remainingDaysMessage = defineMessage({
  defaultMessage: 'Saved for {days} more {days, plural, one {day} other {days}}',
  description: 'Text showing how many days remain before the favorited provider expires',
})

export const remainingHoursMessage = defineMessage({
  defaultMessage: 'Saved for {hours} more {hours, plural, one {hour} other {hours}}',
  description: 'Text showing how many hours remain before the favorited provider expires',
})
